let activeFullscreenTable: HTMLDivElement | null = null;
const listeners = new Set<() => void>();

const notify = () => {
  listeners.forEach((listener) => listener());
};

export const getActiveFullscreenTable = () => activeFullscreenTable;

export const subscribeToFullscreenTable = (listener: () => void) => {
  listeners.add(listener);

  return () => listeners.delete(listener);
};

export const setActiveFullscreenTable = (container: HTMLDivElement) => {
  if (activeFullscreenTable === container) return;

  activeFullscreenTable = container;
  notify();
};

export const clearActiveFullscreenTable = (container: HTMLDivElement) => {
  if (activeFullscreenTable !== container) return;

  activeFullscreenTable = null;
  notify();
};
